import { CorrespondenceType } from '@/shared/types';

export const correspondenceType = [
  {
    key: CorrespondenceType.LEGAL_ENTITY,
    label: 'Юридична особа',
  },
  {
    key: CorrespondenceType.PRIVATE_PERSON,
    label: 'Фізична особа',
  },
];
